<div class="finish">
  @if (isShowConfirmation) {
    <div class="confirmation-block">
      <h1 class="title bold">{{ 'lingo2-game-lib.title-finish-confirmation' | customLocale }} </h1>
      <div class="confirmation-text">
        {{ 'lingo2-game-lib.text-finish-confirmation' | customLocale }}
      </div>
      <div class="button-wrap">
        <div class="btn btn-round" (click)="onConfirm()">{{ 'lingo2-game-lib.action-finish' | customLocale }}</div>
        <div class="btn btn-round btn-primary" (click)="onContinue()">{{ 'lingo2-game-lib.action-continue' | customLocale }}
        </div>
      </div>
    </div>
  }
  @if (!isShowConfirmation) {
    <div class="finish-block">
      <h1 class="title bold">{{ 'lingo2-game-lib.title-finish' | customLocale }}</h1>
      <div class="result-block">
        <!-- если не передали ng-content -->
        <div class="result-item">
          <span class="result result--percent">{{ results.percent }}%</span>
          <span class="explanation medium">{{ 'lingo2-game-lib.label-result-percent' | customLocale }}</span>
        </div>
        <div class="result-item">
          <span class="result">{{ gradeABC }}</span>
          <span class="explanation medium">{{ 'lingo2-game-lib.label-result-grade' | customLocale }}</span>
        </div>
        <div class="result-item">
          <span class="result result--total-points">
            <svg class="result-icon">
              <use [attr.xlink:href]="svgsetIcon('star')"></use>
            </svg>
            {{ results.totalPoints }}
          </span>
          <span class="explanation medium">{{ 'lingo2-game-lib.label-result-points-total' | customLocale }}</span>
        </div>
      </div>
      <div class="button-wrap">
        <div class="btn btn-round btn-primary" (click)="onClose()">{{ 'lingo2-game-lib.action-finish' | customLocale }}</div>
      </div>
    </div>
  }
</div>
